import React, { type ErrorInfo, type PropsWithChildren } from 'react'
import { AppFatalPage } from './AppFatalPage'

interface State {
  hasError: boolean
}

/**
 * Application-level error boundary.
 */
export class AppErrorBoundary extends React.Component<
  PropsWithChildren,
  State
> {
  public state: State = {
    hasError: false
  }

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Must be logged to console at the application level, as the Application
    // probably isn't initialized correctly. There is no remote
    // error-reporting SDK in the portal, so this is the only destination.
    console.error('Uncaught error:', error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      return <AppFatalPage />
    }

    return <>{this.props.children}</>
  }
}

export default AppErrorBoundary
